// components/ui/table/custom-row-table.js
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Table, TableBody, TableHead } from '@mui/material';
import { Scrollbar } from 'src/components/scrollbar';

const CustomRowTable = (props) => {
  const {
    items = [],
    selected = [],
    renderItem,
    children,
  } = props;

  const enableBulkActions = selected.length > 0;

  return (
    <Box sx={{ position: 'relative' }}>
      {enableBulkActions && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: 'center',
            backgroundColor: (theme) =>
              theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.50',
            display: enableBulkActions ? 'flex' : 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            px: 2,
            py: 0.5,
            zIndex: 10,
          }}
        />
      )}
      <Scrollbar sx={{ minHeight: '60vh', overflowY: 'auto', width: '100%' }}>
        <Table sx={{ minWidth: 700 }}>
          <TableHead>{children}</TableHead>
          <TableBody>
            {Array.isArray(items) && (items.length > 0) && (
              items.map((item, index) => {
                //const isSelected = selected.includes(item.id);
                const rowstyle = {
                  backgroundColor: (theme) =>
                    index % 2 === 0
                      ? theme.palette.mode === "dark"
                        ? "rgba(0, 0, 0, 1)" // Dark mode, even row (solid black)
                        : "rgba(255, 255, 255, 1)" // Light mode, even row (solid white)
                      : theme.palette.mode === "dark"
                      ? "rgba(0, 0, 0, 0.1)" // Dark mode, odd row (black with 10% transparency)
                      : "rgba(200, 200, 200, 0.1)", // Light mode, odd row (gray with 10% opacity)
                };
                return (
                  // Directly render the entire row structure provided by renderItem
                  <React.Fragment key={index}>
                    {renderItem(item, rowstyle, index)}
                  </React.Fragment>
                );
              }
            ))
          }
          </TableBody>
        </Table>
      </Scrollbar>
    </Box>
  );
};

CustomRowTable.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.array,
  renderItem: PropTypes.func.isRequired, // Accept a function to render item content
  children: PropTypes.node, // Only children for the header
};

export default CustomRowTable;

{
  // How to use
  // Import
  // import CustomRowTable from 'src/components/ui/table/custom-row-table';
  // import { TableCell, TableRow } from "@mui/material";
  // return (
  //   <CustomRowTable
  //     items={items}
  //     renderItem={(item) => (
  //       <TableRow hover selected={selected.includes(item.id)}>
  //         <TableCell>{item.id}</TableCell>
  //         <TableCell>{item.name}</TableCell>
  //         <TableCell align="right">
  //           <button onClick={() => showLog("Edit", item.id)}>Edit</button>
  //         </TableCell>
  //       </TableRow>
  //     )}
  //   >
  //     {/* Header view at here */}
  //     <TableRow>
  //       <TableCell>Id</TableCell>
  //       <TableCell>Name</TableCell>
  //       <TableCell align="right">Actions</TableCell>
  //     </TableRow>
  //   </CustomRowTable>
  // );
}
